import { DateTime } from 'luxon';

export const MIN_DATE = new Date(0); // January 1, 1970
export const MAX_DATE = new Date('9999-12-31T23:59:59.999Z'); // December 31, 9999

// ISO `YYYY-MM-DD` projections for APIs that take calendar-date strings. Read
// in UTC so the projection is zone-independent: otherwise an east-of-UTC
// default zone rolls MAX_DATE into year 10000 and `toISODate()` emits the
// expanded form (`+010000-01-01`), which fails strict `YYYY-MM-DD` validation.
export const MIN_ISO_DATE = DateTime.fromJSDate(MIN_DATE, {
  zone: 'utc',
}).toISODate();
export const MAX_ISO_DATE = DateTime.fromJSDate(MAX_DATE, {
  zone: 'utc',
}).toISODate();
